import React from "react";
import { Await, useLoaderData, useNavigation } from "react-router-dom";
import { childFinesLoader } from "./childFinesLoader";
import { FinesSharedView } from "./FinesSharedView";
import { FinesSkeltons } from "./FinesSkeltons";
import { useLocationConfiguration } from "@tlc/ls2pac/components/LocationConfiguration";
import { LoaderData } from "../MyAccount";

export const ChildFinesView: React.FC = () => {
  const { data, pageSize } = useLoaderData() as LoaderData<
    typeof childFinesLoader
  >;

  const navigation = useNavigation();
  const { locationConfiguration } = useLocationConfiguration();
  const ecommerceEnabled =
    locationConfiguration?.pacSettings.ecommerceEnabled || false;

  return (
    <React.Suspense
      fallback={
        <FinesSkeltons
          hideActions={true}
          pageSize={pageSize}
          ecommerceEnabled={ecommerceEnabled}
        />
      }
    >
      <Await resolve={data}>
        {({
          sort,
          page,
          pageSize,
          fees,
          childFeesTotalCount,
          childTotalFees,
        }) => {
          return (
            <FinesSharedView
              page={page}
              pageSize={pageSize}
              sort={sort}
              isStudent={true}
              fees={fees}
              feesTotalCount={childFeesTotalCount}
              feesTotalAmount={childTotalFees}
              routeIsLoading={navigation.state === "loading"}
              ecommerceEnabled={ecommerceEnabled}
            />
          );
        }}
      </Await>
    </React.Suspense>
  );
};
